
export default function(_DSB,_CONTEXT={}){

  return function( dataObj, yLabel, limit, sort, type)
  {

      _DSB.log('debug','format.tablev2','Formatting....',[dataObj, yLabel, limit, sort]);
      if (!dataObj.size) return ``;

      /* (Shorter) Utils */
      const _t = (s) => s ? _DSB.helpers.run('format','value',[s.toString(), `titlecase`]) : ``; // To-Title
      const _s = (s) => s ? _DSB.helpers.run('format','value',[s.toString(), `slugify`]) : ``;   // To-Slug

      const sortTables = sort.tables || {};
      const sortTablesOrder = sortTables.order || 'asc';
      const sortRows = sort.rows || {};
      const sortRowsOrder = sortRows.order || 'asc';
      const sortRowsColumn = parseInt(sortRows.column, 10);
      const sortRowsType = sortRows.type;
      const compareOpts = sortRowsType === 'number' || sortRowsType === 'date' ? { numeric: true, senstivity: 'base' } : {};
      const months =  {'Jan':'01','Feb':'02','Mar':'03','Apr':'04','May':'05','Jun':'06','Jul':'07','Aug':'08','Sep':'09','Oct':'10','Nov':'11','Dec':'12'};

      const ROWS_HEADER = _t(yLabel);

      if (sortTables) {
        dataObj = new Map(Array.from(dataObj).sort((a, b) => {
          let A = a[0],
              B = b[0];
          return sortTablesOrder === 'asc' ? A.toLowerCase().localeCompare(B.toLowerCase()) : B.toLowerCase().localeCompare(A.toLowerCase());
        }));
      }

      let html_list = [];
      let prepend_html = false;
      dataObj.forEach((tableData, tableHeader) => {
        let tableRows = Array.from(tableData.values());
        let colHeaders = [ROWS_HEADER].concat(Array.from(tableRows[0].keys()));

        if(sortRows)
        {
          if(!isNaN(sortRowsColumn) && sortRowsColumn >= 0 && sortRowsType !== undefined)
          {
            tableData = new Map(Array.from(tableData).sort((a, b) => {
              let A = sortRowsColumn === 0 ? a[0] : a[1].get(colHeaders[sortRowsColumn]),
                  B = sortRowsColumn === 0 ? b[0] : b[1].get(colHeaders[sortRowsColumn]);

              if (sortRowsType === 'date') {
                let aDateArr = A.split(/-|\/|'|\s+/).filter(d => d).map(d => months[d.trim()] || d.trim());
                let bDateArr = B.split(/-|\/|'|\s+/).filter(d => d).map(d => months[d.trim()] || d.trim());
                A = aDateArr.reverse().join('');
                B = bDateArr.reverse().join('');
              }

              if ((sortRowsType === 'number' || sortRowsType === 'date') && sortRowsOrder === 'asc' && isNaN(parseFloat(B))) return -1;

              return sortRowsOrder === 'asc' ? A.toLowerCase().localeCompare(B.toLowerCase(), undefined, compareOpts) : B.toLowerCase().localeCompare(A.toLowerCase(), undefined, compareOpts);
            }));
          }
        }

        let rowHeaders = Array.from(tableData.keys()).slice(0, limit);
        let tableId = `table_${_s(tableHeader)}`;
        let count = 1;

        let table_element = document.createElement('table');
        let thead_element = document.createElement('thead');
        let tbody_element = document.createElement('tbody');
        table_element.id=tableId+'_'+count;


        let headers_element = document.createElement('tr');
        for(let aHeader of colHeaders)
        {
          let _th_element = document.createElement('th');
          _th_element.scope="col";
          _th_element.innerHTML=aHeader;
          if(aHeader)
          {
            _th_element.class="th--"+_s(aHeader);
          }
          if(aHeader.toString().startsWith(`_`))
          {
            _th_element.style.display='none';
          }
          headers_element.append(_th_element);
        }
        thead_element.append(headers_element);

        for(let aHeaderRow of rowHeaders)
        {
          let _rows_element = document.createElement('tr');
          if(!aHeaderRow.toString().startsWith(`_`))
          {
            let _rows_h_element = document.createElement('th');
            _rows_h_element.scope="row";
            if(colHeaders[0])
            {
              _rows_h_element.class="th--"+_s(colHeaders[0]);
            }
            _rows_h_element.innerHTML=aHeaderRow;
            _rows_element.append(_rows_h_element);
          }
          let _row_values =  Array.from(tableData.get(aHeaderRow).values());

          for(let i=0; i<_row_values.length; i++)
          {
            let _rows_d_element = document.createElement('td');
            if(colHeaders[i+1])
            {
              _rows_d_element.class="td--"+_s(colHeaders[i+1]);
            }
            _rows_d_element.innerHTML=_row_values[i];
            _rows_element.append(_rows_d_element);
          }

          tbody_element.append(_rows_element);
        }
        switch(type)
        {
          case "dropdown":
          {
              if(!(prepend_html instanceof HTMLSelectElement))
              {
                prepend_html=document.createElement('select');
                prepend_html.onchange=function(event)
                {
                  let selected_value = event.target.value;
                  for(let a_table of html_list)
                  {
                    if(a_table instanceof HTMLTableElement)
                    {
                      if(a_table.id==selected_value)
                      {
                        a_table.style.display='table';
                      }
                      else
                      {
                        a_table.style.display='none';
                      }
                    }
                  }
                }
              }
              else
              {
                table_element.style.display='none';
              }
              let anOption=document.createElement('option');
              anOption.value=table_element.id;
              anOption.innerHTML=tableHeader;
              prepend_html.append(anOption);
          }
          default:
          {
            let _caption_element = document.createElement('caption');
            _caption_element.innerHTML=tableHeader;
            table_element.append(_caption_element);
          }
        }

        table_element.append(thead_element);
        table_element.append(tbody_element);
        html_list.push(table_element);
      });

      if(prepend_html instanceof HTMLElement)
      {
        html_list.unshift(prepend_html);
      }

      return html_list;
  }
}
